module.exports = __webpack_public_path__ + "static/img/dingzhi08.0368237.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dingzhi08.jpg
// module id = 0k2v
// module chunks = 0